import { render, staticRenderFns } from "./busR.vue?vue&type=template&id=b0d0517c&scoped=true&"
import script from "./busR.vue?vue&type=script&lang=js&"
export * from "./busR.vue?vue&type=script&lang=js&"
import style0 from "./busR.vue?vue&type=style&index=0&id=b0d0517c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d0517c",
  null
  
)

export default component.exports